import React from "react";
import Link from "gatsby-link";

import GreyBox from "../components/GreyBox";
import CollaboratorsGrid from "../components/CollaboratorsGrid";
import CollaboratorsList from "../components/CollaboratorsList";
import CallToAction from "../components/CallToAction";
import Helmet from "react-helmet";
import Jumbotron from "../components/Jumbotron";
import Testimonials from "../components/testimonials";
import styles from "../styles/about-us.module.scss";
import SectionTitle from "../components/SectionTitle";

import about_1 from "../images/about/about_us_1.jpg";
import about_2 from "../images/about/about_us_2.jpg";
import about_v from "../images/about_v.jpg";

const NotFoundPage = props => {
	return (
		<main role="main">
			<Helmet title="404 | BROKEN LINK" />

			<Jumbotron
				bottomLine={true}
				type="jumbotron_b"
				className="mb-0"
				textAlign="text-center"
				contentAlign="justify-content-md-center"
			>
				<h1>Can't find the page you were looking for</h1>
			</Jumbotron>

			<div className="container mt-5">
				<div className="row justify-content-md-center">
					<div className="col-8">
						<p>
						Something went terribly wrong. Oops! 
						</p>
					</div>
				</div>

			</div>
			

		</main>
	);
};

export default NotFoundPage;




// WEBPACK FOOTER //
// ./src/pages/404.js